export default {
  /**
   * prepare skeleton data for widgets, for pre-render
   * @param {*} dateObj must be in Date Object
   */
  prepareSkeletonData(dateObj){
    // Throw Uncaught exception if cannot find Date Object
    if (!(dateObj instanceof Date)) throw 'Date object expected!'
    const data = { months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'], data: [], labels: [] };   
    dateObj.setDate(1);
    var currentMonth = dateObj.getMonth();
    dateObj.setMonth(0);
    for (var i=0; i<=currentMonth; i++) {
      data.labels.push(data.months[dateObj.getMonth()] + ' ' + dateObj.getFullYear())
      data.data.push({
        month: dateObj.getMonth()+1,
        year: dateObj.getFullYear(),
        index: i
      })
      dateObj.setMonth(dateObj.getMonth() + 1);
    }
    return data;
  },

  getMonthIndex(currentDate, tempDataStore){
    if(currentDate){
      /**
       * Important : As currentDate param contatins only date. not time we don't required 
       * timezone here (If in future needs then update this function by condition)
       */
      let month = new Date(currentDate).getMonth() + 1;
      let year = new Date(currentDate).getFullYear();
      var dataChunk = tempDataStore.data ? tempDataStore.data.filter( objM => objM.month === month && objM.year === year ) : {};
      let index = (typeof dataChunk[0] === 'object' && dataChunk[0].hasOwnProperty("index")) ? dataChunk[0].index : null;
      return index;
    }
    return null;
  },
  
  numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  },
}